export default __webpack_public_path__ + "static/media/pic8.a376d8ec.svg";